var _style, _defs, _g, _g2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUxpilot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 281 47",
    style: {
      enableBackground: "new 0 0 281 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000170246525178911867010000018258596292014248371_);}\n\t.st1{fill:#2F2F37;}\n\t.st2{fill:#3F20FB;}\n\t.st3{fill:#77E7FF;}\n\t.st4{fill:#B377FF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 281,
    height: 47
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091721008131105119980000016211495508242593199_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091721008131105119980000016211495508242593199_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 2.1,
    className: "st1",
    width: 11.8,
    height: 43.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,28.8c0,1.3-0.3,2.5-0.9,3.6c-0.6,1-1.4,1.9-2.5,2.5c-1,0.6-2.2,0.9-3.6,0.9c-1.3,0-2.5-0.3-3.6-0.9 c-1-0.6-1.9-1.4-2.5-2.5c-0.6-1.1-0.9-2.3-0.9-3.6V2.1H0v27.8c0,3.3,0.8,6.2,2.3,8.6c1.6,2.4,3.8,4.3,6.6,5.6 c2.8,1.3,6.1,1.9,9.8,1.9c3.7,0,7-0.6,9.8-1.9c2.8-1.3,5-3.2,6.6-5.6c1.6-2.4,2.4-5.3,2.4-8.6V2.1H25.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.4,4c-2.4-1.3-5.2-1.9-8.4-1.9h-18.7v43.3H122V32.5h6.5c3.3,0,6.2-0.6,8.7-1.8c2.5-1.2,4.4-3,5.8-5.2 c1.4-2.3,2.1-5,2.1-8.1c0-3.1-0.7-5.8-2-8.1C141.7,7,139.8,5.2,137.4,4z M131.9,20.6c-0.5,0.9-1.3,1.6-2.3,2.1 c-1,0.5-2.2,0.7-3.5,0.7H122V11.5h4.1c1.4,0,2.6,0.2,3.5,0.7c1,0.5,1.7,1.1,2.3,2c0.5,0.9,0.8,1.9,0.8,3.2 C132.7,18.6,132.5,19.7,131.9,20.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "243.3,2.1 243.3,11.6 256.3,11.6 256.3,45.4 267.9,45.4 267.9,11.6 280.9,11.6 280.9,2.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.6,4c-3.2-1.7-6.7-2.6-10.7-2.6c-4,0-7.5,0.9-10.7,2.6c-3.2,1.7-5.7,4.2-7.6,7.5 c-1.9,3.3-2.8,7.4-2.8,12.2c0,4.8,0.9,8.8,2.8,12.2c1.9,3.3,4.4,5.8,7.6,7.5c3.2,1.7,6.8,2.6,10.7,2.6c3.9,0,7.5-0.8,10.7-2.5 c3.2-1.7,5.7-4.2,7.6-7.5c1.9-3.3,2.8-7.4,2.8-12.2c0-4.8-0.9-8.9-2.8-12.2C236.4,8.2,233.8,5.7,230.6,4z M227.9,30.3 c-0.7,1.8-1.7,3.1-3,4.1c-1.3,0.9-3,1.4-4.9,1.4c-1.9,0-3.6-0.5-4.9-1.4c-1.3-0.9-2.3-2.3-3-4.1c-0.7-1.8-1-4-1-6.6 s0.3-4.8,1-6.6c0.7-1.8,1.7-3.1,3-4.1c1.3-0.9,3-1.4,4.9-1.4c1.9,0,3.6,0.5,4.9,1.4c1.3,0.9,2.3,2.3,3,4.1c0.7,1.8,1,4,1,6.6 S228.6,28.5,227.9,30.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "178.5,2.1 166.7,2.1 166.7,45.4 196,45.4 196,35.9 178.5,35.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.4,4c-2.4-1.3-5.2-1.9-8.4-1.9h-18.7v43.3H122V32.5h6.5c3.3,0,6.2-0.6,8.7-1.8c2.5-1.2,4.4-3,5.8-5.2 c1.4-2.3,2.1-5,2.1-8.1c0-3.1-0.7-5.8-2-8.1C141.7,7,139.8,5.2,137.4,4z M131.9,20.6c-0.5,0.9-1.3,1.6-2.3,2.1 c-1,0.5-2.2,0.7-3.5,0.7H122V11.5h4.1c1.4,0,2.6,0.2,3.5,0.7c1,0.5,1.7,1.1,2.3,2c0.5,0.9,0.8,1.9,0.8,3.2 C132.7,18.6,132.5,19.7,131.9,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.7,28.8c0,1.3-0.3,2.5-0.9,3.6c-0.6,1-1.4,1.9-2.5,2.5c-1,0.6-2.2,0.9-3.6,0.9c-1.3,0-2.5-0.3-3.6-0.9 c-1-0.6-1.9-1.4-2.5-2.5c-0.6-1.1-0.9-2.3-0.9-3.6V2.1H0v27.8c0,3.3,0.8,6.2,2.3,8.6c1.6,2.4,3.8,4.3,6.6,5.6 c2.8,1.3,6.1,1.9,9.8,1.9c3.7,0,7-0.6,9.8-1.9c2.8-1.3,5-3.2,6.6-5.6c1.6-2.4,2.4-5.3,2.4-8.6V2.1H25.7V28.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 2.1,
    className: "st2",
    width: 11.8,
    height: 43.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "243.3,2.1 243.3,11.6 256.3,11.6 256.3,45.4 267.9,45.4 267.9,11.6 280.9,11.6 280.9,2.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "178.5,2.1 166.7,2.1 166.7,45.4 196,45.4 196,35.9 178.5,35.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.6,4c-3.2-1.7-6.7-2.6-10.7-2.6c-4,0-7.5,0.9-10.7,2.6c-3.2,1.7-5.7,4.2-7.6,7.5 c-1.9,3.3-2.8,7.4-2.8,12.2c0,4.8,0.9,8.8,2.8,12.2c1.9,3.3,4.4,5.8,7.6,7.5c3.2,1.7,6.8,2.6,10.7,2.6c3.9,0,7.5-0.8,10.7-2.5 c3.2-1.7,5.7-4.2,7.6-7.5c1.9-3.3,2.8-7.4,2.8-12.2c0-4.8-0.9-8.9-2.8-12.2C236.4,8.2,233.8,5.7,230.6,4z M227.9,30.3 c-0.7,1.8-1.7,3.1-3,4.1c-1.3,0.9-3,1.4-4.9,1.4c-1.9,0-3.6-0.5-4.9-1.4c-1.3-0.9-2.3-2.3-3-4.1c-0.7-1.8-1-4-1-6.6 s0.3-4.8,1-6.6c0.7-1.8,1.7-3.1,3-4.1c1.3-0.9,3-1.4,4.9-1.4c1.9,0,3.6,0.5,4.9,1.4c1.3,0.9,2.3,2.3,3,4.1c0.7,1.8,1,4,1,6.6 S228.6,28.5,227.9,30.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.6,1.1c4.1-3,9.4,1.5,7.2,6l-8.1,12.6c-0.8,1.6-0.6,3.6,0.4,5l10.1,11.1c3,4.1-1.5,9.4-6,7.2L69.6,35 c-1.6-0.8-3.6-0.6-5,0.4L53.5,45.5c-4.1,3-9.4-1.5-7.2-6l8.1-12.6c0.8-1.6,0.6-3.6-0.4-5L43.9,10.7c-3-4.1,1.5-9.4,6-7.2l12.6,8.1 c1.6,0.8,3.6,0.6,5-0.4L78.6,1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.4,3.7c4.6-2.2,9,3.2,6,7.2l-10.2,11c-1.1,1.4-1.3,3.4-0.5,5l8,12.7c2.2,4.6-3.2,9-7.2,6l-11-10.2 c-1.4-1.1-3.4-1.3-5-0.5l-12.7,8c-4.6,2.2-9-3.2-6-7.2l10.2-11c1.1-1.4,1.3-3.4,0.5-5L46.5,7c-2.2-4.6,3.2-9,7.2-6l11,10.2 c1.4,1.1,3.4,1.3,5,0.5L82.4,3.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.5,2.2c4.3-2.6,9.3,2.3,6.6,6.6l-8.5,11.9c-0.9,1.5-0.9,3.5,0,5l8.5,11.9c2.6,4.3-2.3,9.3-6.6,6.6 l-11.9-8.5c-1.5-0.9-3.5-0.9-5,0l-11.9,8.5C47.3,47,42.4,42,45,37.7l8.5-11.9c0.9-1.5,0.9-3.5,0-5L45,8.9 c-2.6-4.3,2.3-9.3,6.6-6.6l11.9,8.5c1.5,0.9,3.5,0.9,5,0L80.5,2.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxpilot);
export default __webpack_public_path__ + "static/media/uxpilot.3829c1a34622cdb76d8d61777de87462.svg";
export { ForwardRef as ReactComponent };